import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ user }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-6 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
            {getGreeting()}, {user?.name || 'Guest'}!
          </h1>
          <p className="text-base font-body text-muted-foreground">
            Welcome to your Dream Work Shipping dashboard
          </p>
        </div>
        <div className="hidden md:flex items-center space-x-3">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center">
            <Icon name="User" size={32} color="white" />
          </div>
          <div>
            <p className="text-sm font-body text-muted-foreground">Account Status</p>
            <div className="flex items-center space-x-2">
              <span className="px-3 py-1 rounded-full text-sm font-body font-medium bg-success/10 text-success">
                <Icon name="CheckCircle" size={14} className="inline mr-1" />
                {user?.accountStatus || 'Active'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;